import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Users, MapPin, Share2, ArrowRight } from 'lucide-react';

export function GetInvolved() {
  const { t } = useTranslation();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const involveItems = [
    {
      icon: Users,
      title: t('getInvolved.volunteer.title'),
      description: t('getInvolved.volunteer.desc'),
      link: '/volunteer',
      linkText: t('getInvolved.volunteer.cta'),
    },
    // {
    //   icon: DollarSign,
    //   title: t('getInvolved.donate.title'),
    //   description: t('getInvolved.donate.desc'),
    //   link: '/donate',
    //   linkText: t('getInvolved.donate.cta'),
    // },
    {
      icon: MapPin,
      title: t('getInvolved.events.title'),
      description: t('getInvolved.events.desc'),
      link: '/events',
      linkText: t('getInvolved.events.cta'),
    },
    {
      icon: Share2,
      title: t('getInvolved.share.title'),
      description: t('getInvolved.share.desc'),
      link: '/share',
      linkText: t('getInvolved.share.cta'),
    },
  ];

  return (
    <section id="get-involved" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-black text-campaign-black mb-4 relative inline-block">
            {t('getInvolved.title')}
            <span className="absolute -bottom-3 left-1/2 -translate-x-1/2 w-20 h-1 bg-sky-600" />
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {involveItems.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group"
            >
              <div className="bg-gradient-to-br from-gray-50 to-white border-2 border-gray-100 rounded-2xl p-8 text-center h-full transition-all duration-300 hover:border-sky-400 hover:-translate-y-2 hover:shadow-xl">
                <div className="text-5xl mb-4">
                  <item.icon className="mx-auto text-sky-600" size={48} />
                </div>
                <h3 className="text-xl font-heading font-bold text-campaign-black mb-3">
                  {item.title}
                </h3>
                <p className="text-gray-600 mb-6 text-sm leading-relaxed">
                  {item.description}
                </p>
                <Link
                  to={item.link}
                  className="inline-flex items-center gap-2 text-sky-600 font-bold uppercase text-sm tracking-wider group-hover:gap-3 transition-all"
                >
                  {item.linkText}
                  <ArrowRight size={16} />
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}